import * as React from 'react';
import pickListContext from 'src/context/pickListContext';

interface IProps {
	pickListId: number | undefined;
	// own props
	pickListItem?: PickListItemResponseDTO;
}
// convert to stateless component
class PickListText extends React.Component<IProps> {
	public static contextType = pickListContext;
	constructor(props: IProps) {
		super(props);
	}

	public render() {
		if (this.props.pickListItem) {
			return (
				<React.Fragment>{this.props.pickListItem.description}</React.Fragment>
			);
		} else {
			const pickListItemDescription = this.getPickListItem(this.props.pickListId!);
			return <React.Fragment>{pickListItemDescription}</React.Fragment>;
		}
	}

	private getPickListItem = (pickListItemId: number) => {
		const foundPickListItem = this.context.pickListItem
			.find((pItem: PickListItemResponseDTO) => pItem.id === pickListItemId) as PickListItemResponseDTO;
		if (!foundPickListItem) {
			return '';
		}

		return foundPickListItem.description;
	}
}

export default PickListText;